import Lottie from "lottie-react";
import { IoAdd } from "react-icons/io5";
import { Link } from "react-router-dom";
import DefaultButton from "../buttons/defaultButton";
import { _userRole } from "../../../utils/common";
import useUserRole from "../../../hooks/useUserRole";

const NoDataGet = ({
  message = "No data found.",
  lottie,
  folderFucnction,
  fileLink,
  isStudent,
}) => {
  const role = useUserRole();
  return (
    <div className="flex flex-col items-center justify-center text-disabled text-center w-full h-full">
      <div className="w-60 h-60">
        <Lottie animationData={lottie} loop />
      </div>

      <p className="text-md font-medium text-theme -mt-6">{message}</p>

      {!isStudent &&
        (role === _userRole.WORKSPACE_ADMIN || role === _userRole.STAFF) && (
          <div className="text-sm font-medium text-textLight flex flex-row items-center justify-center gap-1">
            {/* <DefaultButton
              name="Create Folder"
              onClick={folderFucnction}
              icon={<IoAdd />}
            />

            {fileLink && (
              <DefaultButton
                name="Upload File"
                onClick={fileLink}
                icon={<IoAdd />}
              />
            )} */}
            <p
              onClick={folderFucnction}
              className="cursor-pointer flex items-center gap-1 text-textLight hover:text-theme hover:underline"
            >
              <IoAdd />
              Create Folder
            </p>
            /
            {fileLink && (
              <p
                onClick={fileLink}
                className="cursor-pointer flex items-center gap-1 text-textLight hover:text-theme hover:underline"
              >
                Upload File
              </p>
            )}
          </div>
        )}
    </div>
  );
};

export default NoDataGet;
